import * as Sentry from '@sentry/react';

const errorNotifier = {
  notify: async (err: unknown, context = {}) => {
    if (process.env.NODE_ENV === 'development') {
      window.console && console.error && console.error(err);
    }

    if (process.env.NODE_ENV === 'production') {
      Sentry.captureException(err, { extra: context });
    }
  },
  notifyWithFingerprint: async (
    err: Error,
    fingerprint: string[],
    context = {},
  ) => {
    if (process.env.NODE_ENV === 'development') {
      window.console && console.error && console.error(err);
    }

    if (process.env.NODE_ENV === 'production') {
      Sentry.captureException(err, { fingerprint, extra: context });
    }
  },
};

export { errorNotifier };
